import clsx from 'clsx';
import {map, startsWith} from 'lodash';
import {useLocation} from 'react-router';

import BarChart from 'components/Chart/Bar';
import LineChart from 'components/Chart/Line';
import ReadableWidthTemplate from 'components/Templates/ReadableWidth';

import './index.scss';


export default function GitHubProfilePage() {
  const location = useLocation();
  const {gitHubMetaData} = location.state;
  const {languageStats, commits, gitHubAccount} = gitHubMetaData;


  return (
    <ReadableWidthTemplate title="GitHub Stats Page" className="gitHubProfilePage">
      {renderAccount(gitHubAccount)}
      {renderBarChart(languageStats)}
      {renderLineChart(commits)}
    </ReadableWidthTemplate>
  );
}


function renderAccount(gitHubAccount) {
  if (!gitHubAccount) {
    return null;
  }

  const {name, email, imageUrl, bio, company, location, blog, following, followers, publicRepoCount} = gitHubAccount;
  let link = blog;
  if (!startsWith(blog, 'https://')) {
    link = 'https://' + blog;
  }
  return (
    <div className="card profile-card p-4 text-center">
      {imageUrl && (
        <div className="d-flex justify-content-center">
          <img src={imageUrl} alt={name} className="profile-img" />
        </div>
      )}
      {name && (<h2 className="mt-3 mb-1">{name}</h2>)}
      {bio && (<p className="text-muted mb-2">{bio}</p>)}
      {email && (<p className="mb-1"><strong>Email:</strong>{' '}{email}</p>)}
      {company && (<p className="mb-1"><strong>Company:</strong>{' '}{company}</p>)}
      {location && (<p className="mb-1"><strong>Location:</strong>{' '}{location}</p>)}

      {link && (<p><a href={link} target="_blank" rel="noreferrer">{' '}Visit Website</a></p>)}

      <div className="row mt-4">
        <div className="col-4 stat">
          <h6>Followers</h6>
          <p>{followers}</p>
        </div>
        <div className="col-4 stat">
          <h6>Following</h6>
          <p>{following}</p>
        </div>
        <div className="col-4 stat">
          <h6>Repos</h6>
          <p>{publicRepoCount}</p>
        </div>
      </div>
    </div>
  );
}

function renderBarChart(languages) {
  if (Object.keys(languages).length === 0) {
    return null;
  }
  const data = map(Object.keys(languages), (language) => ({
    label: language, value: languages[language],
  }));

  return (
    <>
      <h2>The language coverage on GitHub</h2>
      <figure className={clsx('caFigure')}>
        <BarChart
          data={data}
          horizontal={true}
          showLabels={true}
        />
        <figcaption className="text-center text-muted">
          Usage of languages on GitHub.
        </figcaption>
      </figure>
    </>

  );
}

function renderLineChart(commits) {
  if (Object.keys(commits).length === 0) {
    return null;
  }
  const data = map(Object.keys(commits), (week) => ({
    label: week, value: commits[week],
  }));

  return (
    <>
      <h2>The count of commits per week on GitHub</h2>
      <LineChart
        data={data}
        style={{height: '18rem'}}
        xAxisLabel={{
          title: 'Week',
        }}
        yAxisLabel={{
          title: 'Commit Count',
        }}
      />
    </>
  );
}
